export default (index, boardArray) => {
  if (boardArray[index] === '.') {
    return true;
  }

  const col = index % 9; //Math.floor(index / 3);
  const row = Math.floor(index / 9);


  // BEGIN WINDOW VALIDATION
  const w = Math.floor(col / 3) + Math.floor(row / 3) * 3; // windowIndex one of 0, 1, 2, ..., 8 window indexes
  const e = boardArray[index];
  const valuesInWindow = [];

  // console.log('index: ',index, 'element: ', e, 'row: ', row, 'col: ', col, 'window: ', w);

  const firstIndexOfWindows = Math.floor(w / 3) * 3 * 9 + (w % 3) * 3;

  if (index !== firstIndexOfWindows + 0) valuesInWindow.push(boardArray[firstIndexOfWindows + 0]);
  if (index !== firstIndexOfWindows + 1) valuesInWindow.push(boardArray[firstIndexOfWindows + 1]);
  if (index !== firstIndexOfWindows + 2) valuesInWindow.push(boardArray[firstIndexOfWindows + 2]);
  if (index !== firstIndexOfWindows + 9 + 0) valuesInWindow.push(boardArray[firstIndexOfWindows + 9 + 0]);
  if (index !== firstIndexOfWindows + 9 + 1) valuesInWindow.push(boardArray[firstIndexOfWindows + 9 + 1]);
  if (index !== firstIndexOfWindows + 9 + 2) valuesInWindow.push(boardArray[firstIndexOfWindows + 9 + 2]);
  if (index !== firstIndexOfWindows + 18 + 0) valuesInWindow.push(boardArray[firstIndexOfWindows + 18 + 0]);
  if (index !== firstIndexOfWindows + 18 + 1) valuesInWindow.push(boardArray[firstIndexOfWindows + 18 + 1]);
  if (index !== firstIndexOfWindows + 18 + 2) valuesInWindow.push(boardArray[firstIndexOfWindows + 18 + 2]);

  // console.log(index, e, w, firstIndexOfWindows, valuesInWindow);

  if (valuesInWindow.includes(e)) return false;
  // END WINDOW VALIDATION

  // BEGIN ROW VALIDATION
  const firstIndexOfRow = row * 9;
  const valuesInRow = [];

  if (index !== firstIndexOfRow + 0) valuesInRow.push(boardArray[firstIndexOfRow + 0]);
  if (index !== firstIndexOfRow + 1) valuesInRow.push(boardArray[firstIndexOfRow + 1]);
  if (index !== firstIndexOfRow + 2) valuesInRow.push(boardArray[firstIndexOfRow + 2]);

  if (index !== firstIndexOfRow + 3) valuesInRow.push(boardArray[firstIndexOfRow + 3]);
  if (index !== firstIndexOfRow + 4) valuesInRow.push(boardArray[firstIndexOfRow + 4]);
  if (index !== firstIndexOfRow + 5) valuesInRow.push(boardArray[firstIndexOfRow + 5]);

  if (index !== firstIndexOfRow + 6) valuesInRow.push(boardArray[firstIndexOfRow + 6]);
  if (index !== firstIndexOfRow + 7) valuesInRow.push(boardArray[firstIndexOfRow + 7]);
  if (index !== firstIndexOfRow + 8) valuesInRow.push(boardArray[firstIndexOfRow + 8]);

  if (valuesInRow.includes(e)) return false;
  // END ROW VALIDATION

  // BEGIN COLUMN VALIDATION
  const firstIndexOfCol = index % 9;
  const valuesInCol = [];
  // console.log(index, e, w, firstIndexOfCol);

  if (index !== firstIndexOfCol + 9 * 0) valuesInCol.push(boardArray[firstIndexOfCol + 9 * 0]);
  if (index !== firstIndexOfCol + 9 * 1) valuesInCol.push(boardArray[firstIndexOfCol + 9 * 1]);
  if (index !== firstIndexOfCol + 9 * 2) valuesInCol.push(boardArray[firstIndexOfCol + 9 * 2]);

  if (index !== firstIndexOfCol + 9 * 3) valuesInCol.push(boardArray[firstIndexOfCol + 9 * 3]);
  if (index !== firstIndexOfCol + 9 * 4) valuesInCol.push(boardArray[firstIndexOfCol + 9 * 4]);
  if (index !== firstIndexOfCol + 9 * 5) valuesInCol.push(boardArray[firstIndexOfCol + 9 * 5]);

  if (index !== firstIndexOfCol + 9 * 6) valuesInCol.push(boardArray[firstIndexOfCol + 9 * 6]);
  if (index !== firstIndexOfCol + 9 * 7) valuesInCol.push(boardArray[firstIndexOfCol + 9 * 7]);
  if (index !== firstIndexOfCol + 9 * 8) valuesInCol.push(boardArray[firstIndexOfCol + 9 * 8]);

  if (valuesInCol.includes(e)) return false;
  // END COLUMN VALIDATION

  return true;
}
